import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/home/HeroSection';
import BenefitsSection from '../components/home/BenefitsSection';
import ProcessSection from '../components/home/ProcessSection';
import ServicesSection from '../components/home/ServicesSection';
import StatsSection from '../components/home/StatsSection';
import FAQSection from '../components/home/FAQSection';
import BlogPreviewSection from '../components/home/BlogPreviewSection';
import CTASection from '../components/home/CTASection';
import PartnersSection from '../components/home/PartnersSection';

const HomePage = () => {
  // NOTE: All Schema.org structured data is provided by SSG (generate-static-pages.js).
  // React does NOT inject schemas to ensure SSG <-> DOM parity and avoid duplicates.
  // SSG provides: WebSite, SoftwareApplication, Organization, FAQPage for the homepage.

  return (
    <div className="min-h-screen bg-white">
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Unternehmensbewertung Schweiz – kostenlos berechnen</title>
        <meta name="description" content="Was ist Ihr Unternehmen wert? Kostenlose, anonyme Unternehmensbewertung für Schweizer KMU – in 3 Minuten zur ersten Wertindikation." />
        <meta name="keywords" content="Unternehmensbewertung, Firmenwert berechnen, Firma bewerten, Unternehmen verkaufen, Unternehmen kaufen, KMU Schweiz" />
        <link rel="canonical" href="https://www.unternehmenbewerten.ch/" />
      </Helmet>
      
      <Header />
      
      <main>
        {/* Hero - Main value proposition */}
        <HeroSection />
        
        {/* Partners - Network (directly under hero) */}
        <PartnersSection />
        
        {/* Stats - Social proof */}
        <StatsSection />
        
        {/* Benefits - Why choose us */}
        <BenefitsSection />
        
        {/* Process - How it works */}
        <ProcessSection />
        
        {/* Services - Our offerings */}
        <ServicesSection />
        
        {/* FAQ - Common questions */}
        <FAQSection />
        
        {/* Blog Preview - Content marketing */}
        <BlogPreviewSection />
        
        {/* CTA - Final conversion */}
        <CTASection />
      </main>
      
      <Footer />
      {/* NOTE: Schema.org structured data is provided by SSG in the <head> section.
          React does NOT inject additional schemas to avoid duplicates after hydration.
          SSG schemas: WebSite, SoftwareApplication, Organization, FAQPage */}
    </div>
  );
};

export default HomePage;
